// action - state management
import * as actionTypes from './actions';

export const initialState = {
  message: null,
  type: null
};

// ==============================|| NOTIFICATION REDUCER ||============================== //

// Define reducer function
const notificationReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.SET_NOTIFICATION:
      return {
        ...state,
        message: action.payload.message,
        type: action.payload.type
      };
    case actionTypes.CLEAR_NOTIFICATION:
      return {
        ...state,
        message: null,
        type: null
      };
    default:
      return state;
  }
};

export default notificationReducer;
